import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import axios from 'util/axios';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Pagination, { SetPager } from "util/component/Pagination/v2";

import { GotoList } from "../Functions";

const VIEW_PAGE = 6;

const MyTempSave = (props, ref) => {
    const [List, SetList] = useState([]);
    const [Loading, SetLoading] = useState(true);
    const userSelector = useSelector((store) => store.user);
    const { t } = useTranslation(["page"]);

    const TBL_DATA_ORIGIN = useRef([]);
    const [PAGER, SetPAGER] = useState(null);

    const [ Sorting, SetSorting ] = useState({column: "createDt", order: "asc"})

    const getList = async () => {
        SetLoading(true);
        try {
            const response = await axios
                .post(process.env.REACT_APP_API + "/pcsList/retrievePcsTempListForMypage", {
                    userId: "'" + userSelector.userId + "'",
                })
                .then((Response) => Response.data.data.result);

            TBL_DATA_ORIGIN.current = response || [];
            const pager = new SetPager(TBL_DATA_ORIGIN.current.length, VIEW_PAGE);
            SetPAGER({ data: pager });
        } catch (e) {
            SetList([]);
        } finally {
            SetLoading(false);
        }
    };

    useEffect(() => {
        if (!PAGER) return;
        const range = PAGER.data.getItemRange();
        let setData = [];

        TBL_DATA_ORIGIN.current?.sort((a,b) => {
            if(Sorting.order === "asc") {
                if(a[Sorting.column] > b[Sorting.column]) return 1
                if(a[Sorting.column] === b[Sorting.column]) return 0
                if(a[Sorting.column] < b[Sorting.column]) return -1
                return 0
            } else {
                if(a[Sorting.column] > b[Sorting.column]) return -1
                if(a[Sorting.column] === b[Sorting.column]) return 0
                if(a[Sorting.column] < b[Sorting.column]) return 1
                return 0
            }
        })

        for (let i = range.start; i < range.end; i++) {
            setData.push(TBL_DATA_ORIGIN.current[i]);
        }
        SetList(setData);
    }, [PAGER, Sorting]);

    const HandleSort = (column) => {
        SetSorting(OLD => ({column: column, order: (OLD.column === column && OLD.order === "desc") ? "asc" : "desc"}))
    }

    useEffect(() => {
        getList();

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return (
        <div className={"position-relative"}>
            <div className={"refresh-btn"} onClick={getList}>
                <FontAwesomeIcon icon={faArrowRotateRight} />
            </div>
            <table
                className={"bpl-table-default small compact has-pagination fixed text-center"}
                style={{ fontSize: "0.9rem" }}
            >
                <colgroup>
                    <col width="90" />
                    <col width="90" />
                    <col width="100" />
                    <col />
                    {/* <col width="90" /> */}
                    <col width="60" />
                </colgroup>
                <thead>
                    <tr>
                        <th className={`clickable sort-header ${Sorting.column === "projectNm" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("projectNm")}
                        >
                            Project
                        </th>
                        <th className={`clickable sort-header ${Sorting.column === "mbrNo" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("mbrNo")}
                        >
                            MBR No.
                        </th>
                        <th>Revision</th>
                        <th className={`clickable sort-header ${Sorting.column === "createDt" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("createDt")}
                        >Last Save Date</th>
                        {/* <th className={`clickable sort-header ${Sorting.column === "remain" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("remain")}
                        >Remain</th> */}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {!Loading &&
                        (List && List.length > 0) ? List?.map((rowData, index) => {
                            const { sheetCode, projectNm, mbrNo, revision, createDt } = rowData;
                            return (
                                <tr key={`myTempSaveList${index}`}>
                                    <td className={"clickable"} onClick={() => GotoList("projectNm", projectNm)}>{projectNm}</td>
                                    <td className={"clickable"} onClick={() => GotoList("mbrNo", mbrNo)}>{mbrNo}</td>
                                    <td>
                                        <span className={"bpl-temp-v2"}>{`${revision}`}</span>
                                    </td>
                                    <td style={{ fontSize: "0.9rem" }}>{createDt}</td>
                                    {/* <td>{`${remain} ${t("days")}`}</td> */}
                                    <td>
                                        <button
                                            className={`bpl-btn small thin`}
                                            style={{ fontSize: "0.75rem" }}
                                            onClick={() => {window.location.href = "/mainForm?mid="+sheetCode+"&rev="+revision+"&tempYn=Y";}}
                                        >
                                            Link
                                        </button>
                                    </td>
                                </tr>
                            );
                        }) : (
                            <tr>
                                <td colSpan={5}>No Results</td>
                            </tr>
                        )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="5">
                            <Pagination
                                data={PAGER?.data}
                                v2
                                set={(data) => SetPAGER({ data: data, refresh: new Date() })}
                            />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};
export default MyTempSave;
